import { useQuery } from '@tanstack/react-query';
import { reservationApi } from '@/api/reservations';

/**
 * React Query hook to fetch a specific reservation
 */
export function useReservation(storeDomain: string | null, reservationUuid: string | null) {
  return useQuery({
    queryKey: ['reservation', storeDomain, reservationUuid],
    queryFn: () => {
      if (!storeDomain || !reservationUuid) {
        throw new Error('Store domain and reservation UUID are required');
      }
      return reservationApi.getReservation(storeDomain, reservationUuid);
    },
    enabled: !!storeDomain && !!reservationUuid,
    staleTime: 30 * 1000,
    retry: 2,
  });
}
